import { render, staticRenderFns } from "./SearchGroupSales.vue?vue&type=template&id=51e6d660&scoped=true"
import script from "./SearchGroupSales.vue?vue&type=script&lang=js"
export * from "./SearchGroupSales.vue?vue&type=script&lang=js"
import style0 from "./SearchGroupSales.vue?vue&type=style&index=0&id=51e6d660&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e6d660",
  null
  
)

export default component.exports